var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4252.67,-2.39844 H -1.50781 V 4252 H 4252.67 V -2.39844",
    style: {
      fill: "#1e305f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 635.063,3895.44 V 3037.7 H 490.848 v 656.6 h -1.289 l -101.204,-105 h -1.238 v 150.54 l 132.856,155.6 h 115.09",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 700.848,3895.44 H 1062.7 V 3762.61 L 874.18,3037.7 H 731.156 l 192.336,740.12 H 700.848 v 117.62",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1400.59,3855 v -141.5 h 22.26 c 20.66,0 29.68,10.07 29.68,29.68 v 82.68 c 0,19.59 -9.02,29.14 -29.68,29.14 z m -60.42,49.28 h 89.56 c 60.95,0 83.21,-30.21 83.21,-80.55 v -75.79 c 0,-50.34 -22.26,-81.07 -83.21,-81.07 h -29.14 v -121.89 h -60.42 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1586.62,3658.92 h 48.22 l -23.85,144.14 h -0.52 z m -75.78,-113.94 67.83,359.3 h 68.9 l 68.36,-359.3 h -62.01 l -11.13,65.72 h -64.12 l -10.6,-65.72 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1798.62,3855 v -111.82 h 20.14 c 20.66,0 29.68,10.59 29.68,29.68 v 53 c 0,19.59 -9.02,29.14 -29.68,29.14 z m 0,-145.21 v -164.81 h -60.42 v 359.3 h 87.97 c 60.95,0 83.2,-30.21 83.2,-80.55 v -46.11 c 0,-38.68 -13.78,-61.46 -48.22,-69.41 l 57.76,-163.23 h -63.59 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1927.41,3904.28 h 160.58 V 3855 h -49.82 v -310.02 h -60.95 V 3855 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2164.31,3770.73 v -225.75 h -50.87 v 359.3 h 59.35 l 65.19,-206.14 v 206.14 h 50.34 v -359.3 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2320.13,3904.28 h 144.15 V 3855 h -83.74 v -102.81 h 59.89 v -48.76 h -59.89 v -109.17 h 83.74 v -49.28 h -144.15 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2554.38,3855 v -111.82 h 20.14 c 20.67,0 29.68,10.59 29.68,29.68 v 53 c 0,19.59 -9.01,29.14 -29.68,29.14 z m 0,-145.21 v -164.81 h -60.41 v 359.3 h 87.97 c 60.95,0 83.2,-30.21 83.2,-80.55 v -46.11 c 0,-38.68 -13.77,-61.46 -48.22,-69.41 l 57.76,-163.23 h -63.59 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2691.66,3757.48 h 84.79 v -48.75 h -84.79 v 48.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1337,3122.36 v 48.22 h 56.17 v -49.29 c 0,-20.13 9.01,-31.79 29.68,-31.79 19.07,0 27.56,12.71 27.56,31.79 v 13.78 c 0,20.67 -8.49,33.39 -27.03,50.87 l -35.51,35.51 c -34.44,33.91 -50.34,54.59 -50.34,95.92 v 12.18 c 0,44.53 25.96,78.97 84.79,78.97 60.41,0 84.26,-29.68 84.26,-81.61 v -29.15 h -55.12 v 31.27 c 0,20.66 -9.54,30.74 -28.61,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.68 v -7.42 c 0,-20.14 11.13,-31.79 28.62,-48.76 l 38.68,-38.15 c 32.86,-33.38 48.76,-53.52 48.76,-93.27 V 3125 c 0,-49.28 -26.5,-84.25 -87.97,-84.25 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1539.45,3137.72 v 173.82 c 0,56.18 26.51,96.98 90.1,96.98 66.77,0 85.31,-37.1 85.31,-90.09 v -42.39 h -55.11 v 47.16 c 0,22.25 -7.42,34.98 -29.15,34.98 -21.73,0 -30.73,-15.37 -30.73,-37.1 v -192.9 c 0,-21.72 9,-37.09 30.73,-37.09 21.73,0 29.15,13.78 29.15,34.97 v 66.25 h 55.11 v -62 c 0,-51.41 -21.19,-89.56 -85.31,-89.56 -63.59,0 -90.1,41.32 -90.1,96.97",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1863.8,3203.43 h -58.29 v -158.45 h -60.41 v 359.3 h 60.41 v -152.09 h 58.29 v 152.09 h 60.94 v -359.3 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2022.8,3158.92 h 48.22 l -23.84,144.14 h -0.53 z m -75.78,-113.94 67.83,359.3 h 68.9 l 68.36,-359.3 h -62 l -11.14,65.72 h -64.12 l -10.59,-65.72 h -57.24",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2174.38,3404.28 h 141.5 V 3355 h -81.08 v -102.81 h 60.41 v -48.76 h -60.41 v -158.45 h -60.42 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2335.5,3404.28 h 160.56 V 3355 h -49.81 v -310.02 h -60.94 V 3355 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2521.52,3404.28 h 144.14 V 3355 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2746.23,3270.73 v -225.75 h -50.88 v 359.3 h 59.35 l 65.19,-206.14 v 206.14 h 50.34 v -359.3 h -53 l -71,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1399,2594.26 h 91.68 v -49.28 h -154.74 v 49.28 l 94.86,260.73 h -85.32 v 49.29 h 148.91 v -49.29 L 1399,2594.26",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1698.96,2904.28 v -271.85 c 0,-55.65 -23.84,-91.68 -85.31,-91.68 -63.59,0 -90.1,36.03 -90.1,91.68 v 271.85 h 60.42 V 2626.6 c 0,-21.21 8.48,-35.51 29.68,-35.51 21.19,0 29.67,14.3 29.67,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1791.2,2854.99 v -111.81 h 20.14 c 20.67,0 29.67,10.59 29.67,29.68 v 52.99 c 0,19.6 -9,29.14 -29.67,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.3 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.56 v -46.1 c 0,-38.68 -13.78,-61.46 -48.22,-69.41 l 57.75,-163.23 h -63.58 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1985.18,2904.28 h 144.15 v -49.29 h -83.73 v -102.8 h 59.89 v -48.76 h -59.89 v -109.17 h 83.73 v -49.28 h -144.15 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2219.43,2854.99 v -111.81 h 20.14 c 20.67,0 29.68,10.59 29.68,29.68 v 52.99 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.3 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.56 v -46.1 c 0,-38.68 -13.78,-61.46 -48.22,-69.41 l 57.75,-163.23 h -63.58 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2420.84,2854.99 v -111.81 h 20.13 c 20.67,0 29.68,10.59 29.68,29.68 v 52.99 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.42 v 359.3 h 87.97 c 60.94,0 83.2,-30.2 83.2,-80.56 v -46.1 c 0,-38.68 -13.78,-61.46 -48.22,-69.41 l 57.76,-163.23 h -63.59 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2561.81,2904.28 h 144.15 v -49.29 h -83.73 v -102.8 h 59.89 v -48.76 h -59.89 v -109.17 h 83.73 v -49.28 h -144.15 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2735.65,2904.28 h 60.42 v -359.3 h -60.42 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2828.4,2637.72 v 173.82 c 0,56.18 26.5,96.98 90.09,96.98 66.77,0 85.32,-37.1 85.32,-90.09 v -42.39 h -55.11 v 47.16 c 0,22.25 -7.42,34.98 -29.15,34.98 -21.73,0 -30.73,-15.37 -30.73,-37.1 v -192.9 c 0,-21.72 9,-37.09 30.73,-37.09 21.73,0 29.15,13.78 29.15,34.97 v 66.25 h 55.11 v -62 c 0,-51.41 -21.19,-89.56 -85.32,-89.56 -63.59,0 -90.09,41.32 -90.09,96.97",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3152.74,2703.43 h -58.29 v -158.45 h -60.42 v 359.3 h 60.42 v -152.09 h 58.29 v 152.09 h 60.94 v -359.3 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3420.92,2904.28 v -271.85 c 0,-55.65 -23.85,-91.68 -85.33,-91.68 -63.59,0 -90.08,36.03 -90.08,91.68 v 271.85 h 60.41 V 2626.6 c 0,-21.21 8.47,-35.51 29.67,-35.51 21.2,0 29.68,14.3 29.68,35.51 v 277.68 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3503.6,2770.74 v -225.76 h -50.87 v 359.3 h 59.36 l 65.17,-206.14 v 206.14 h 50.36 v -359.3 h -53 l -71.02,225.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3750.58,2736.82 h 85.85 v -191.84 h -43.45 v 39.21 c -7.95,-27.02 -24.92,-43.44 -57.77,-43.44 -51.93,0 -75.78,41.32 -75.78,96.97 v 173.82 c 0,56.18 27.02,96.98 90.62,96.98 66.77,0 86.38,-37.1 86.38,-90.09 v -31.8 h -55.11 v 36.57 c 0,22.25 -8.48,34.98 -30.21,34.98 -21.73,0 -31.27,-15.37 -31.27,-37.1 v -192.9 c 0,-21.72 9.02,-37.09 29.68,-37.09 19.61,0 29.68,11.12 29.68,34.44 v 63.6 h -28.62 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1426.02,2094.26 c 24.92,0 34.46,14.85 34.46,36.57 v 188.13 c 0,21.2 -9.54,36.03 -34.46,36.03 h -25.43 v -260.73 z m 94.87,213.57 v -166.4 c 0,-55.12 -22.79,-96.45 -87.44,-96.45 h -93.28 v 359.3 h 93.28 c 64.65,0 87.44,-40.81 87.44,-96.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1552.7,2404.28 h 144.14 v -49.29 h -83.73 v -102.8 H 1673 v -48.76 h -59.89 v -109.17 h 83.73 v -49.28 H 1552.7 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1786.95,2354.99 v -111.81 h 20.14 c 20.67,0 29.68,10.59 29.68,29.68 v 52.99 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.3 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.56 v -46.1 c 0,-38.68 -13.78,-61.46 -48.22,-69.41 l 57.75,-163.23 h -63.58 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2039.76,2094.26 h 91.68 v -49.28 H 1976.7 v 49.28 l 94.86,260.73 h -85.32 v 49.29 h 148.91 v -49.29 l -95.39,-260.73",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2164.31,2404.28 h 60.42 v -359.3 h -60.42 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2257.07,2404.28 h 144.14 v -49.29 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2430.9,2404.28 h 60.42 v -310.02 h 72.07 v -49.28 H 2430.9 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2588.31,2404.28 h 144.14 v -49.29 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2383.5,1204.83 c 74.64,69.26 121.49,168.1 121.49,277.75 0,16.4 -1.16,32.55 -3.18,48.43 151.69,-16.25 270.27,-144.96 270.27,-300.95 0,-88.6 -38.51,-168.18 -99.46,-223.61 -57.03,106.88 -163.75,183.31 -289.12,198.38 m 257.29,-376.209 c 0,-166.851 -135.8,-302.641 -302.71,-302.641 -54.32,0 -105.14,14.559 -149.25,39.711 64.38,67.957 104.08,159.661 104.08,260.418 0,24.801 -2.51,49.039 -7.06,72.52 54.42,-30.25 116.97,-47.539 183.54,-47.539 59.21,0 115.31,13.68 165.25,38.031 4.03,-19.57 6.15,-39.789 6.15,-60.5 m -1029.58,-2.512 c 0,21.52 2.3,42.481 6.62,62.723 49.87,-24.172 105.76,-37.742 164.78,-37.742 66.36,0 128.69,17.18 182.99,47.242 -4.22,-22.594 -6.54,-45.883 -6.54,-69.711 0,-102.359 40.92,-195.332 107.13,-263.601 -44.8,-26.239 -96.75,-41.551 -152.27,-41.551 -166.95,0 -302.71,135.769 -302.71,302.64 m -131.29,403.951 c 0,155.99 118.54,284.68 270.23,300.95 -2.01,-15.88 -3.18,-32.03 -3.18,-48.43 0,-110.79 47.82,-210.62 123.82,-279.98 -125.71,-14.31 -232.95,-90.29 -290.59,-196.93 -61.38,55.41 -100.28,135.37 -100.28,224.39 m 646.04,555.2 c 124.04,0 230.73,-75.01 277.48,-182.01 -123.14,-21.71 -225.93,-102.99 -277.48,-212.97 -51.47,110 -154.3,191.28 -277.44,212.97 46.75,107 153.45,182.01 277.44,182.01 m 72.09,-688.54 c 41.94,22 89.47,34.6 140.03,34.6 119,0 221.88,-69.21 271.35,-169.32 -41.96,-22.008 -89.57,-34.609 -140.04,-34.609 -119.04,0 -221.93,69.211 -271.34,169.329 m -145.12,-2.04 c -49.8,-99.02 -152.12,-167.289 -270.32,-167.289 -50.14,0 -97.37,12.468 -139.05,34.129 49.8,99.03 152.15,167.29 270.36,167.29 50.15,0 97.33,-12.45 139.01,-34.13 m -225.68,434.44 c 145.75,-21.67 258.07,-147.32 258.07,-299.06 0,-15.83 -1.61,-31.31 -3.98,-46.5 -145.78,21.7 -258.05,147.3 -258.05,299.02 0,15.86 1.59,31.34 3.96,46.54 m 300.13,-917.311 c -56.67,55.031 -92.01,131.851 -92.01,216.812 0,83.688 34.19,159.527 89.22,214.369 56.63,-55.029 92,-131.849 92,-216.881 0,-83.64 -34.15,-159.468 -89.21,-214.3 m 301.29,870.771 c 0,-151.72 -112.28,-277.32 -258.05,-299.02 -2.37,15.19 -3.93,30.67 -3.93,46.5 0,151.74 112.27,277.37 258.02,299.05 2.37,-15.19 3.96,-30.67 3.96,-46.53 m 419.72,-252.52 c 0,204.36 -162.57,371.33 -365.09,378.7 -52.09,147.11 -192.58,252.81 -357.34,252.81 -164.72,0 -305.19,-105.7 -357.34,-252.81 -202.51,-7.39 -365,-174.35 -365,-378.7 0,-121.25 57.32,-229.33 146.25,-298.759 -9.66,-33.43 -14.98,-68.699 -14.98,-105.192 0,-208.91 170.02,-378.949 379.03,-378.949 79.3,0 152.96,24.551 213.9,66.371 60.22,-40.301 132.53,-63.84 210.26,-63.84 208.97,0 378.99,170.02 378.99,378.93 0,35.77 -5.07,70.34 -14.35,103.117 88.56,69.462 145.67,177.332 145.67,298.322",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe17);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-17.8ad03bcc7ec6caae248cc6fdbce7dbb4.svg";
export { ForwardRef as ReactComponent };